import { VOID_CAREPLAN_EXPIRY_PERIOD } from 'op-enums';
import React from 'react';

export type TenantContextType = {
  doseUnit: string;
  setDoseUnit: (val: string) => void;
  ariaDoseUnit: string;
  setAriaDoseUnit: (val: string) => void;
  mosaiqDoseUnit: string;
  setMosaiqDoseUnit: (val: string) => void;
  fractionUnit: string;
  setFractionUnit: (val: string) => void;
  voidCareplanExpiryPeriod: number;
  setVoidCareplanExpiryPeriod: (val: number) => void;
  showTreatmentReview: boolean;
  setShowTreatmentReview: (val: boolean) => void;
  showManageProtocols: boolean;
  setShowManageProtocols: (val: boolean) => void;
  showIsocenterField: boolean;
  setShowIsocenterField: (val: boolean) => void;
};

export const TenantContext = React.createContext<TenantContextType>({
  doseUnit: 'Gy',
  setDoseUnit: () => {},
  ariaDoseUnit: 'Gy',
  setAriaDoseUnit: () => {},
  mosaiqDoseUnit: 'cGy',
  setMosaiqDoseUnit: () => {},
  fractionUnit: '#',
  setFractionUnit: () => {},
  voidCareplanExpiryPeriod: VOID_CAREPLAN_EXPIRY_PERIOD,
  setVoidCareplanExpiryPeriod: () => {},
  showTreatmentReview: false,
  setShowTreatmentReview: () => {},
  showManageProtocols: false,
  setShowManageProtocols: () => {},
  showIsocenterField: false,
  setShowIsocenterField: () => {},
});
